import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

import { CheckboxFilters } from '~/src/components/CheckboxFilters';

export const FiltersForTariffs = styled.div`
    width: 100%;
    align-items: center;
    justify-content: space-beetwen;
    flex-direction: row;
    margin-bottom: 16px;
    gap: 24px;
`;

export const TariffSwitcherWrap = styled.div<{isDisplay: boolean}>`
    display: ${p => p.isDisplay ? 'block' : 'none'};
`;

export const SCheckboxFilters = styled(CheckboxFilters)`
    margin-top: 0;
    margin-left: 0;

    div:first-child {
        margin-left: 0;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        div {
            margin-left: 0;
            
            &:not(:last-child) {
                margin-bottom: 16px;
            }
        }
    }
`;
